import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { resolveStorageUrl } from "../utils/storageUrl";

const CategoryImage = ({ src, alt }) => {
  const [failed, setFailed] = useState(false);
  const url = resolveStorageUrl(src);

  if (!url || failed) {
    return (
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: 1.5,
          bgcolor: "grey.100",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption" color="text.secondary">
          No image
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={url}
      alt={alt}
      sx={{
        width: 48,
        height: 48,
        borderRadius: 1.5,
        objectFit: "cover",
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "grey.50",
      }}
      onError={() => setFailed(true)}
    />
  );
};

const Categories = ({ categories, onToggleActive, edit, deleteItem }) => {
  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Table size="medium" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Image</TableCell>
            <TableCell>Order</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Active</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {categories && categories.length > 0 ? (
            categories.map((category) => (
              <TableRow key={category.id} hover>
                <TableCell>
                  <Typography fontWeight={500}>{category.category_name}</Typography>
                </TableCell>
                <TableCell>
                  <CategoryImage
                    src={category.category_image}
                    alt={category.category_name}
                  />
                </TableCell>
                <TableCell>{category.category_order}</TableCell>
                <TableCell>
                  <Typography variant="body2" textTransform="capitalize">
                    {category.category_type}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Switch
                    checked={!!category.active}
                    onChange={() =>
                      onToggleActive(category.id, category.active)
                    }
                    color="primary"
                    size="small"
                  />
                </TableCell>
                <TableCell align="right">
                  <IconButton
                    size="small"
                    onClick={() => edit(category.id)}
                    title="Edit"
                    sx={{ color: "primary.main", mr: 0.5 }}
                  >
                    <Edit fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => deleteItem(category.id)}
                    title="Delete"
                  >
                    <Delete fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6} align="center" sx={{ py: 6 }}>
                <Typography color="text.secondary">
                  No categories found. Add one to get started.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Categories;
